import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=4b191eca&scoped=true"
import script from "./aptitude.vue?vue&type=script&lang=js"
export * from "./aptitude.vue?vue&type=script&lang=js"
import style0 from "./aptitude.vue?vue&type=style&index=0&id=4b191eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b191eca",
  null
  
)

export default component.exports